module.exports = __webpack_public_path__ + "img/pin.b2afa9ee.svg";